import { useContext } from 'react';

import { LocationContext } from 'state/location';

function useLocation() {
  return useContext(LocationContext);
}

export default useLocation;
